import { resolve } from 'redux-optimist-promise';
import { PREPARE_BE } from 'Store/booking/proposals/constants';
import { FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID } from './constants';
type State = Array<StreetViewWithAccommodationCategoryId>;
const initialState: State = [];
export function streetViewsReducer(
  state: State = initialState,
  action: Action<any>,
): State | null | undefined {
  switch (action?.type) {
    case PREPARE_BE:
    case resolve(FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID): {
      return action?.payload?.streetViews || [];
    }

    default:
      return state;
  }
}
